import { Pipe, PipeTransform } from '@angular/core';

export type ImageAssetPath = '' | 'countries' | 'payment-method' | 'payment-method-groups' | 'product-type';
export type ImageAssetPathDict = { [key in ImageAssetPath]: { defaultName: string; path: string; valueCase: 'uppercase' | 'lowercase' } };

export const ImageAssetPathMap: ImageAssetPathDict = {
  ['']: { defaultName: '', path: '', valueCase: 'lowercase' },
  ['countries']: { defaultName: 'country', path: 'countries', valueCase: 'lowercase' },
  ['payment-method']: { defaultName: 'payment-method', path: 'payment-images', valueCase: 'lowercase' },
  ['payment-method-groups']: { defaultName: 'payment-method-group', path: 'payment-images', valueCase: 'lowercase' },
  ['product-type']: { defaultName: 'product-type', path: 'product_types', valueCase: 'uppercase' },
};

@Pipe({
  name: 'imageAsset',
  standalone: true,
})
export class ImageAssetPipe implements PipeTransform {
  transform(value: string | undefined = undefined, path: ImageAssetPath): string {
    if (!value) {
      return '';
    }

    const mappedPath = ImageAssetPathMap[path];

    if (value.startsWith('/') && value.length > 1) {
      value = value.substring(1, value.length);
    }

    if (mappedPath.valueCase === 'uppercase') {
      value = value.toUpperCase();
    } else {
      value = value.toLowerCase();
    }

    if (value.includes('.SVG')) {
      value = value.replace('.SVG', '.svg');
    }

    if (!value.includes('.svg')) {
      value = value + '.svg';
    }

    if (!value.includes(path)) {
      value = `${mappedPath.path}/${value}`;
    }

    return `https://static.pay.nl/${value}`;
  }
}
